/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ActionButton } from '@fluentui/react/lib/Button';
import { IButtonProps } from '@fluentui/react/lib/components/Button/Button.types';
import { IIconProps } from '@fluentui/react/lib/components/Icon';
import { Stack } from '@fluentui/react/lib/Stack';

import * as React from 'react';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../utilities/Utils';
import {
    actionButtonStyles,
    chevronIconStyles,
    containerStyle,
    stackStyles,
    stackTokens,
} from './EsignNavigationBar.styles';

export interface MobileNavigationBarProps {
    returnButtonProps: IButtonProps;
    completeButtonProps: IButtonProps;
}

export const EsignNavigationBar: React.FC<MobileNavigationBarProps> = (
    props: MobileNavigationBarProps
): JSX.Element => {
    const { returnButtonProps, completeButtonProps } = props;

    const chevronIconProps: IIconProps = {
        iconName: getHTMLDir(getAppHost().getLocaleName()) === 'rtl' ? 'ChevronRight' : 'ChevronLeft',
        styles: chevronIconStyles,
    };

    return (
        <div className='navigation-bar' style={containerStyle()}>
            <Stack
                horizontal={true}
                horizontalAlign={'space-between'}
                verticalAlign={'center'}
                tokens={stackTokens}
                styles={stackStyles}>
                <Stack.Item>
                    <ActionButton {...returnButtonProps} iconProps={chevronIconProps} styles={actionButtonStyles} />
                </Stack.Item>
                <Stack.Item>
                    <ActionButton {...completeButtonProps} styles={actionButtonStyles} />
                </Stack.Item>
            </Stack>
        </div>
    );
};
